/**
 * Frontend mirror of capitalmanagement-api/services/backdatePolicy.js.
 *
 * AFFORDANCE ONLY — decides which controls to show and what minimum a date picker offers. Every rule
 * is enforced server-side; the policy itself comes from GET /contracts/settings/workflow
 * (`backdate` + `maturedAmendment`).
 */
import { format, addDays, subDays, parseISO } from 'date-fns';

const todayStr = () => format(new Date(), 'yyyy-MM-dd');

// DATE columns arrive from the API as 'YYYY-MM-DD' strings.
const toDateStr = (d) => (typeof d === 'string' ? d.slice(0, 10) : format(d, 'yyyy-MM-dd'));

/**
 * Earliest permitted date (YYYY-MM-DD) for a backdate rule, or null when unlimited / unknown.
 * @param {{enabled:boolean, days:number|null}|undefined} rule
 */
export const earliestAllowedDate = (rule) => {
  if (!rule) return null;
  if (rule.enabled === false) return todayStr();
  if (rule.days === null || rule.days === undefined) return null;
  return format(subDays(parseISO(todayStr()), rule.days), 'yyyy-MM-dd');
};

/**
 * Is a matured contract still inside its post-maturity amendment window?
 * @returns {{ open: boolean, windowClosesOn: string|null }}
 */
export const getMaturedAmendmentWindow = (contract, maturedAmendment) => {
  if (contract?.status !== 'Matured' || !contract?.maturity_date || !maturedAmendment?.enabled) {
    return { open: false, windowClosesOn: null };
  }
  const windowClosesOn = format(addDays(parseISO(toDateStr(contract.maturity_date)), maturedAmendment.days), 'yyyy-MM-dd');
  return { open: todayStr() <= windowClosesOn, windowClosesOn };
};
